var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37409 7.93177C7.62593 7.93177 8.64075 6.91695 8.64075 5.6651C8.64075 4.41326 7.62593 3.39844 6.37409 3.39844C5.12224 3.39844 4.10742 4.41326 4.10742 5.6651C4.10742 6.91695 5.12224 7.93177 6.37409 7.93177Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77148 13.4583C1.77148 11.1208 3.82565 9.5625 6.37565 9.5625C8.92565 9.5625 10.9798 11.1208 10.9798 13.4583",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0409 7.86302C13.058 7.86302 13.8826 7.03848 13.8826 6.02135C13.8826 5.00423 13.058 4.17969 12.0409 4.17969C11.0238 4.17969 10.1992 5.00423 10.1992 6.02135C10.1992 7.03848 11.0238 7.86302 12.0409 7.86302Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 9.70312C12.9618 9.91563 14.4493 11.3323 14.4493 13.2448",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.03fa279e2eefc6753ac019f36e293df7.svg";
export { ForwardRef as ReactComponent };